<template>
  <moo-popover popper-class="popper-avatar" placement="left" width="160" v-model="visible" trigger="hover"
    :close-delay="0">
    <div class="avatar-pop">
      <div class="user-info">
        <div :style="avatarColor" slot="reference" class="user-avatar">
          <span class="select-name-avatar" v-if="!userInfo.memberAvatar">
            {{ userInfo.memberName?.slice(-2) }}
          </span>
          <img v-else slot="reference" :src="memberAvatar" class="inner-avatar" />
        </div>
        <div class="user-content">
          <div class="user-name">{{ userInfo.memberName }}</div>
          <div class="user-tissue">
            {{ departMentInfo }}
          </div>
        </div>
      </div>
    </div>
    <div slot="reference" class="user-item">
      <div :style="avatarColor" slot="reference" class="file-avatar">
        <span class="select-name-avatar" v-if="!userInfo.memberAvatar">
          {{ userInfo.memberName?.slice(-2) }}
        </span>
        <img v-else slot="reference" :src="memberAvatar" class="user-select-avatar" />
      </div>
      <span>{{ userInfo.memberName }}</span>
    </div>
  </moo-popover>
</template>

<script>
import { getNameColor } from '@/utils/color';
import { fetchUserInfo } from '@/api/sso/auth';
import { mapState } from 'vuex';

export default {
  props: {
    userInfo: {
      type: Object
    }
  },
  data() {
    return {
      visible: false,
      data: {}
    };
  },
  methods: {
    handleSignOut() {
      this.$emit('handleLogOutShow');
    }
  },
  computed: {
    ...mapState({
      isPcMode: state => state.isPcMode
    }),
    departMentInfo() {
      return this.data.departments?.map(item => item.departmentName).join('/');
    },
    avatarColor() {
      return {
        background: getNameColor(this.userInfo.memberName)
      };
    },
    memberAvatar() {
      try {
        const avatarInfo = JSON.parse(this.data.memberAvatar);

        return avatarInfo[300];
      } catch { }
    }
  },
  mounted() {
    if (this.userInfo?.spaceId && this.userInfo?.userId && this.isPcMode) {
      fetchUserInfo({
        spaceId: this.userInfo?.spaceId,
        userId: this.userInfo?.userId
      })
        .then(res => {
          if (res.code === 200) {
            this.data = res.data;
          }
        })
        .catch(err => {
          // console.log('fetchUserInfo', err);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.user-item {
  display: flex;
  flex-flow: row;
  width: 164px;
  height: 40px;
  border-radius: 4px;
  align-items: center;
  padding: 4px 12px;
  box-sizing: border-box;
  cursor: pointer;

  &:hover {
    background: #f1f2f5;
  }

  .file-avatar {
    width: 26px;
    height: 26px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 12px;

    .select-name-avatar {
      font-family: PingFangSC-SNaNpxibold;
      font-weight: 600;
      font-size: 12px;
      color: #ffffff;
      letter-spacing: 0;
    }

    .user-select-avatar {
      width: 26px;
      height: 26px;
    }
  }

  .inner-avatar {
    margin: 0 !important;
    width: 100%;
    height: 100%;
    flex-shrink: 0;
  }

  span {
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 14px;
    color: #121317;
    letter-spacing: 0;
    line-height: 20px;
  }
}

.avatar-pop {
  width: 280px;
  height: auto;
  background: #ffffff;
  border: 1px solid #e6e8ec;
  box-shadow: 0 8px 12px 0 #1213171a;
  border-radius: 8px;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  padding: 16px;
  box-sizing: border-box;

  .sign-out {
    margin-top: 16px;
    line-height: 44px;
    padding-left: 8px;
    width: 248px;
    height: 44px;
    border-radius: 8px;
  }

  .sign-out:hover {
    background: #f4f6f9;
  }

  .user-info {
    display: flex;
    flex-flow: row;

    .user-avatar {
      width: 48px;
      height: 48px;
      border-radius: 8px;
      margin-right: 14px;
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      font-family: PingFangSC-SNaNpxibold;
      font-weight: 600;
      font-size: 16px;
      color: #ffffff;
      letter-spacing: 0;
    }

    .user-content {
      display: flex;
      flex-flow: column;

      .user-name {
        font-family: PingFangSC-SNaNpxibold;
        font-weight: 600;
        font-size: 17px;
        color: #121317;
        line-height: 24px;
      }

      .user-tissue {
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 12px;
        color: #646573;
      }
    }
  }
}

.popper-avatar {
  width: 280px !important;
  height: auto !important;
  padding: 0 !important;
  /* left: 445px !important; */
  box-sizing: border-box;

  .popper__arrow {
    display: none !important;
  }
}
</style>
